// src/modules/auth/index.ts
import { AuthProvider, AuthContext, useServerAuth } from '../../contexts/auth-provider';

export { default as LoginForm } from './ui/login-form';
export { useAuth } from './hooks/use-auth';
export { authenticateUser, getTokenService, authenticatedFetch } from './services/auth-service';
export type { AuthUser, AuthResponse } from './types/auth';
export { useAuthStore } from './stores/auth-store';
export { useAuthenticatedFetch } from './hooks/useAuthenticatedFetch';
export { AuthProvider, AuthContext, useServerAuth }; // Esportazione esplicita di AuthContext
export { AuthEventKeys } from './events';
export type { AuthEvents } from './events';
export { default as LoginScreen } from './screen/login-screen';
